
import React, { useCallback, useState, useEffect } from "react";
//import {getRequest} from '../../services/axiosEnterpriseNewBaseClient'
import { getRequest } from "../../services/axiosBaseClient";
import styles from "./Battery.module.scss";
import cn from "classnames";
import BattriesSwapListTable from "./BattriesSwapListTable";
import TableSwapHistory from "../common/TableSwapHistory";
import styled from "styled-components";

var pageLimit = 10;
var offset = 0;

const Styles = styled.div`
  table {
    th,
    td {
      border-bottom: 1px solid #f5f5ff;
      border-right: 0px solid black;
      padding: 8px;
      white-space: nowrap;
      text-align: start;

      :last-child {
        border-right: 0;
        text-align: left;
      }
    }
  }
`;

export default function BatteryAnalytics(props) {
  const { id } = props;

  const [dataTable, setDataTable] = useState([]);
  const [swapStationCount, setSwapStationCount] = useState(0);

  const pageLimitHandle = (string, limit, types) => {
    getBatterySwappingHistory(string, limit, types);
  };

  const getBatterySwappingHistory = useCallback(
    async (offset, limit, types) => {
      // if (types === "front") {
      //   offset = offset + 1;
      // } else {
      //   if (offset > 0) {
      //     offset = offset - 1;
      //   }
      // }
      await getRequest(
        `bss/getBatterySwapHistory?batteryId=${id}&limit=${
          limit ? limit : pageLimit
        }&offset=${offset > 0 ? offset : 0}`
      )
        .then((res) => {
          if (res?.data?.response) {
            setSwapStationCount(res.data?.count);
            res?.data?.response?.map((obj) => {
              obj.swapDate = obj.swapDate.slice(0, 19);
            });
            setDataTable(res?.data?.response);
          }
        })
        .catch((err) => {
          console.log(err, "ERROR");
        });
    },
    [dataTable, swapStationCount]
  );

  useEffect(() => {
    pageLimitHandle();
    getBatterySwappingHistory();
  }, []);

  const columns = React.useMemo(() => [
    // {
    //   Header: "A",
    //   hideHeader: true,
    //   columns: [
    {
      Header: "Driver Name",
      accessor: "driverName",
    },
    {
      Header: "Swap Station Name",
      accessor: "swapStationName",
    },
    {
      Header: "Slot Name",
      accessor: "slotName",
    },
    {
      Header: "Vehicle ID",
      accessor: "vehicleId",
    },
    {
      Header: "Swap Type",
      accessor: "swapType",
    },
    {
      Header: "SOC (%)",
      accessor: "soc",
      Cell: (props) => {
        let socValue =
          props?.row?.original?.soc !== null
            ? props?.row?.original?.soc.split(".")
            : "";
        return (
          <>
            <span>{socValue ? socValue[0] + "%" : ""}</span>
          </>
        );
      },
    },
    {
      Header: "Date-Time",
      accessor: "swapDate",
    },
    //   ],
    // },
  ]);

  return (
    <>
      <div
        styles={{ backgroundColor: "#FFFFFF" }}
        className={cn(styles.block25, styles.block25_layout)}
      >
        <Styles>
          <TableSwapHistory
            columns={columns}
            data={dataTable}
            paginationCountHanlde={pageLimitHandle}
            swapStationCount={swapStationCount}
            paginationDoubleScreen={false}
          />
        </Styles>
      </div>
    </>
  );
}
